export default "__VITE_ASSET__BCnir59u__"